import { getSupabaseClient } from "../Components/Database/supabaseClient";

const supabase = getSupabaseClient();

class FirebaseService {
  static async update(firebaseUid, updateData) {
    // Assume that you want to update the 'user_data' column with the 'elements' array
    const formattedUpdateData = {
      user_data: updateData.elements, // Updating the 'user_data' column with the elements array
    };

    const { data, error, status } = await supabase
      .from("users")
      .update(formattedUpdateData) // Pass the formatted update data
      .eq("firebase_uid", firebaseUid); // Matching the user by firebase_uid

    if (error) {
      console.error("Error saving user data:", error);
    }

    return { data, error, status };
  }

  static async get(firebaseUid) {
    const { data, error, status } = await supabase
      .from("users")
      .select("*")
      .eq("firebase_uid", firebaseUid);

    if (error) {
      console.error("Error fetching user data:", error);
    }
    return { data, error, status };
  }

  static async isUserExiste(filters) {
    let query = supabase.from("users").select("*");

    if (filters.firebase_uid)
      query = query.eq("firebase_uid", filters.firebase_uid);
    if (filters.email) query = query.eq("email", filters.email);
    if (filters.user_name) query = query.eq("user_name", filters.user_name);

    const { data, error, status } = await query;

    if (error) {
      console.error("Error fetching user data:", error);
    }
    return { data, error, status };
  }

  static async upsertUser(firebaseUid, updateData) {
    const { data, error, status } = await supabase.from("users").upsert(
      { firebase_uid: firebaseUid, ...updateData },
      { onConflict: ["firebase_uid"] } // Ensures update if UID exists
    );

    if (error) {
      console.error("Error saving user data:", error);
    }

    return { data, error, status };
  }
}

export default FirebaseService;
